"use client";

import * as React from "react";
import { Drawer } from "vaul";
import { useWalletPortfolioContext } from "../providers/wallet-portfolio-provider";
import { shortenAddress } from "../../../lib/format";

export interface WalletPortfolioTriggerProps {
  asChild?: boolean;
  children?: React.ReactNode;
}

export function WalletPortfolioTrigger({
  asChild,
  children,
}: WalletPortfolioTriggerProps) {
  const { walletAddress } = useWalletPortfolioContext();

  const hasChildren = children != null;
  const shouldAsChild = asChild ?? true;

  const triggerContent = hasChildren ? (
    children
  ) : (
    <button type="button">{shortenAddress(walletAddress)}</button>
  );

  return (
    <Drawer.Trigger asChild={shouldAsChild}>{triggerContent}</Drawer.Trigger>
  );
}
